import React, { useState } from "react";
import { CapabilityDTO } from "../types/capabilityDTO";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { fi } from 'date-fns/locale';
import { registerLocale } from "react-datepicker";

registerLocale('fi', fi);

type Args = {
  headerText: string;
  capability: CapabilityDTO;
  submitted: (capability: CapabilityDTO) => void;
  deleted?: (capability: CapabilityDTO) => void;
};

const CapabilityForm = ({ headerText, capability: capability, submitted, deleted }: Args) => {
  const { t, i18n } = useTranslation();
  const nav = useNavigate();
  const [capabilityState, setCapabilityState] = useState(capability);

  const onSubmit: React.MouseEventHandler<HTMLButtonElement> = async (e) => {
    e.preventDefault();
    submitted(capabilityState);
  };

  const onCancel: React.MouseEventHandler<HTMLButtonElement> = async (e) => {
    e.preventDefault();
    nav(-1);
  };

  const onDelete: React.MouseEventHandler<HTMLButtonElement> = async (e) => {
    e.preventDefault();
    deleted?.(capabilityState);
  };

  const handleCapabilitySpecifierChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const specifier = parseInt(e.target.value);
    setCapabilityState({ ...capabilityState, specifier: specifier });
  };

  return (
    <div className="ml-3">
      <h5 className="subtitle text-left mb-2">{headerText}</h5>
      <form>
        {/* <div className="form-group">
          <label htmlFor="id">Id</label>
          <input
            type="text"
            className="form-control"
            placeholder="Id"
            value={capabilityState.id}
            readOnly
          />
        </div>
        <div className="form-group">
          <label htmlFor="orgId">Organisation Id</label>
          <input
            type="text"
            className="form-control"
            placeholder="Organisation Id"
            value={capabilityState.organisationId}
            readOnly
          />
        </div> */}
        <div className="form-group">
          <label htmlFor="name">{t('common.name')}</label>
          <input
            type="text"
            maxLength={200}
            className="form-control"
            value={capabilityState.name}
            onChange={(e) =>
              setCapabilityState({ ...capabilityState, name: e.target.value })
            }
          />
        </div>
        <div className="form-group">
          <label htmlFor="specifier" className="form-label">{t('capability.specifier')}</label>
          <select
            id="specifier"
            className="form-control"
            value={capabilityState.specifier}
            onChange={handleCapabilitySpecifierChange}>
            <option key="0" value="0">
              {t('capability.notSpecified')}
            </option>
            <option key="1" value="1">
              {t('capability.sectionLeader')}
            </option>
            <option key="2" value="2">
              {t('capability.platoonLeader')}
            </option>
          </select>
        </div>
        <div className="form-group mt-2">
          <label htmlFor="validFrom">{t('common.validFrom')}</label>
          <div>
            <DatePicker
              className="form-control"
              dateFormat={i18n.language === 'en' ? 'yyyy-MM-dd hh:mm' : 'dd.MM.yyyy HH:mm'}
              locale={i18n.language === 'fi' ? 'fi' : 'en'}
              selected={capabilityState.validFrom}
              onChange={(date: Date | null) => date && setCapabilityState({ ...capabilityState, validFrom: date })}
              showTimeSelect
            />
          </div>
        </div>
        <div className="form-group mt-2">
          <label htmlFor="validTo">{t('common.validTo')}</label>
          <div>
            <DatePicker
              className="form-control"
              dateFormat={i18n.language === 'en' ? 'yyyy-MM-dd hh:mm' : 'dd.MM.yyyy HH:mm'}
              locale={i18n.language === 'fi' ? 'fi' : 'en'}
              selected={capabilityState.validTo}
              onChange={(date: Date | null) => date && setCapabilityState({ ...capabilityState, validTo: date })}
              showTimeSelect
            />
          </div>
        </div>
        <button
          className="btn btn-primary mt-3 me-2"
          disabled={!capabilityState.name}
          onClick={onSubmit}>
          {t('buttons.save')}
        </button>
        {deleted && (
          <button
            className="btn btn-danger mt-3 me-2"
            onClick={onDelete}>
            {t('buttons.delete')}
          </button>
        )}
        <button
          className="btn btn-danger mt-3"
          onClick={onCancel}>
          {t('buttons.cancel')}
        </button>
      </form>
    </div>
  );
};

export default CapabilityForm;
